import { buildUrl } from "../helpers/common";
import { debounce, isEqual, isEmpty } from "lodash";
import filterTemplateService from "@/services/manage/filterTemplate";

/* eslint-disable */
export default {
    watch: {
        '$route': {
            deep: true,
            handler() {
                // reset nextPage
                this.nextPage = 1;
                this.initalizeUrlQuery();
                this.initQuerySearch();
                if (isEmpty(this.currentQuery)) {
                    this.page = 1;
                    this.reset();
                    this.setSearchCaching();
                }
                if (Object.prototype.hasOwnProperty.call(this, 'searchList')) {
                    this.executeFunc();   // should define in component if using this mixin
                }
                window.setSearchingRoute(this.currentRouteName);
                // if (this.isBlankQueryForm()) {
                //   this.reset();
                // }
            }
        },
    },

    beforeMount() {
        // mr.quan edit
        this.initQuerySearch();
        this.initalizeUrlQuery();
        this.autoSearch && this.executeFunc();
        if (this.useFilterTemplate) {
            this.fetchTemplateCode();
        }
    },
    mounted() {
        window.setSearchingRoute(this.currentRouteName)
    },
    data() {
      return {
        loading: false,
        currentId: null,
        currentFullPath: null,
        currentPath: null,
        currentRouteName: null,
        currentQuery: {},
        // list item searching
        listItems: [],

        // pagination
        page: 1,
        total: 0,
        perPage: 0,
        lastPage: 1,
        autoSearch: true,

        // caching search
        cacheForm: {},
        isUsingPaginate: true,
        //
        nextPage: 1,
        useFilterTemplate: false,
        filterTemplate: {
            template_code: "",
            name: "",
            condition: "",
        },
        functionalCode: null,
      }
    },

    computed: {
        titleFilterTemplate() {
            return (!isEmpty(this.filterTemplate?.name) && this.useFilterTemplate)
              ? this.$t("filter-template.label_display_template_search", {
                  name: this.filterTemplate.name,
              })
              : this.$t('panel.label_search');
        }
    },

    methods: {
        searching: debounce(function (e) {
            if (this.isUsingPaginate) {
                // remove page query in current query
                if (this.currentQuery.page) {
                    delete this.currentQuery.page;
                }
                this.prepareForExecuteSearching();
                // this.currentQuery = { ...this.form, page: this.currentQuery.page };
                this.currentQuery = { ...this.form, page: this.nextPage };

            } else {
                this.prepareForExecuteSearching();
                this.currentQuery = { ...this.form };
            }
            // if (!this.checkSameUrl()) {
            //     this.changeQueryRouteVue();
            // } else {
            //     this.executeFunc();
            //     return;
            // }
            // setting cache-form
            if ((this.filterTemplate?.template_code) && this.useFilterTemplate) {
                this.currentQuery.template_code = this.filterTemplate?.template_code;
            }
            this.setSearchCaching()
        }, 200),
        // searching() {
        //     if (this.isUsingPaginate) {
        //         if (this.currentQuery.page) {
        //             delete this.currentQuery.page;
        //         }
        //         if (!_.isEqual(this.form, this.currentQuery)) { // compare old and new
        //             this.currentQuery.page = 1;
        //         } else {
        //             this.currentQuery.page = this.page;
        //         }
        //         this.currentQuery = { ...this.form, page: this.currentQuery.page };
        //     } else {
        //         this.currentQuery = { ...this.form };
        //     }

        //     if (!this.checkSameUrl()) {
        //         this.changeQueryRouteVue();
        //     }
        //     // setting cache-form
        //     this.setSearchCaching()
        // },
        prepareForExecuteSearching() {
            if (!this.compareFormAndCurrentQuery()) { // compare old and new
                // this.currentQuery.page = 1;
                if (this.isUsingPaginate) {
                    this.nextPage = 1;
                }
                this.changeQueryRouteVue();
            } else {
                // this.currentQuery.page = this.page;
                if (this.isUsingPaginate){
                    this.nextPage = this.page; // get the current page from pagination component
                }
                this.executeFunc();
                return;
            }
        },

        compareFormAndCurrentQuery() {
            return isEqual(this.form, this.currentQuery);
        },

        checkSameUrl() {
            let buildQueryUrlPath = buildUrl(this.currentPath, this.form);
            return this.currentFullPath === buildQueryUrlPath;
        },

        initalizeUrlQuery() {
            this.currentFullPath = this.$route.fullPath;
            this.currentPath = this.$route.path;
            this.currentRouteName = this.$route.name;
            this.currentQuery = this.$route.query;
            if (this.currentQuery.page) {
                this.page = this.currentQuery.page
            }

        },

        changeQueryRouteVue() {
            let form = {
                ...this.form
            }
            if (this.isUsingPaginate) {
                form['page'] = this.nextPage
            }
            let query = Object.assign({}, { ...form })

            if ((this.filterTemplate?.template_code) && this.useFilterTemplate) {
                query.template_code = this.filterTemplate?.template_code;
            }
            this.$router.push({ query }).catch(()=>{});
        },

        changePage(changePageNumber) {
            this.page = changePageNumber;
            this.nextPage = changePageNumber;
            // load cache to fresh 
            this.form = {...this.cacheForm};
            // this.currentQuery = {
            //     ...this.form, page: this.page
            // }
            this.changeQueryRouteVue();
            // this.searching();
            //let querybuilder =  buildUrl(this.currentPath, this.currentQuery);
            // console.log(querybuilder);
            // let query = Object.assign({}, this.currentQuery)
            // this.$router.replace({ query });
            // this.searchList();
        },

        // submit form handle searching
        onSubmit(event) {
            event.preventDefault();
            // call searching function in searchingMixins
            this.searching();
        },

        async executeFunc() {
            try {
               await this.searchList();
               
            } catch (err) {
                this.loading = false;
                this.handleErrorSearching(err);
            }   
        },

        initQuerySearch(checkTemplateCode = true) {
            if (!this.$route.query.template_code && checkTemplateCode) {
                this.filterTemplate = {
                    template_code: "",
                    name: "",
                    condition: "",
                };
            }
            if (!isEmpty(this.$route.query)) {
                this.reset();
                if (typeof this.form != 'undefined') {
                    for (const prop in this.$route.query) {
                        if (this.form.hasOwnProperty(prop)) {
                            this.form[prop] = this.$route.query[prop];
                        }
                    }
                }
            }
            // save cache-form
            this.setSearchCaching();
        },

        removeItem(id) {
            this.currentId = id;
        },

        handleResultSearching({ data, current_page, per_page, total, last_page }) {
            this.listItems = data;
            this.page = current_page;
            this.total = total;
            this.perPage = per_page;
            this.lastPage = last_page;

            if (this.lastPage < this.page) {
                this.page = null;
            }
        },

        handleDeleteSuccess() {
            this.currentId = null;
            this.deleteSuccess();
            this.searchList();
            this.scrollTopWindow();
        },

        // handle error when request fail
        errorSystem(msg = null) {
            this.$errorSystem(msg);
        },

        // handle delete success
        deleteSuccess() {
            this.$alertSuccess(this.$t('panel.label_delete_success'));
        },

        // isBlankQueryForm() {
        //   let emptyForm = false;

        //   if (_.isEmpty(this.currentQuery)) {
        //     emptyForm = true;
        //     return emptyForm;
        //   }

        //   for (const prop in this.form) {
        //     if (this.currentQuery.hasOwnProperty(prop)) {
        //       emptyForm = true;
        //       return emptyForm;
        //     }
        //   }
        // }
        handleErrorSearching(error) {
            if (error.forbidden) {
                this.errorSystem(error.data || '');
                // emit to component <base-managem-permission-view/>
                // this.$eventBus.$emit('management_not_allow_to_access');
                this.redirect403();
                return;
            }
            this.errorSystem();
        },
        redirect403() {
            let routePath = this.$route.path;
            if (/^\/admin/.test(routePath)) {
                this.$router.replace({
                    name: 'AdminPageUnauthorized'
                });
                return;
            } else if (/^\/manage/.test(routePath)) {
                this.$router.replace({
                    name: 'MananagePageUnauthorized'
                });
                return;
            }
        },
        // fix for navigation of page (when change page, not get the current data of form)
        setSearchCaching() {
            this.cacheForm = {...this.form};
        },

        settingFilterTemplate({ template_code, name, condition }){
            this.filterTemplate.template_code = template_code;
            this.filterTemplate.name = name;
            this.filterTemplate.condition = condition;
            let formQuery = this.convertQueryStringToObjectQuery(this.filterTemplate.condition);
            // append
            formQuery.template_code = this.filterTemplate.template_code;
            formQuery.page = 1;
            this.nextPage = 1;
            this.$router
                .push({
                    query: {
                        ...formQuery,
                    },
                })
                .catch(() => {});
            this.initQuerySearch(false);
        },
        deleteTemplate(template_code) {
            if (this.filterTemplate.template_code == template_code) {
                this.filterTemplate.template_code = "";
                this.filterTemplate.name = "";
                this.filterTemplate.condition = "";
            }
        },
        async fetchTemplateCode() {
            const { query } = this.$route;
            if (query?.template_code) {
              let response = await filterTemplateService.getDetailTemplateCode({
                functional_code: this.functionalCode,
                template_code: query.template_code,
              });
              if (response) {
                const { template_code, name, condition } = response;
                this.filterTemplate.template_code = template_code;
                this.filterTemplate.name = name;
                this.filterTemplate.condition = condition;
              }
            }
          },

        convertQueryStringToObjectQuery(queryString) {
            const params = new URLSearchParams(queryString);
            const result = {};
            // loop key URL SEARCH PARAMS
            for (const [key, value] of params.entries()) {
                const regex = /(\w+)\[(\d+)\]/; // <key>[0], <key>[1]
                const match = regex.exec(key);
                if (match) {
                    const [_, arrayKey, index] = match;
                    if (!result[arrayKey]) { // add key to objectQuery
                        result[arrayKey] = [];
                    }
                    result[arrayKey][index] = value;
                } else {
                    // Normal key-value pair
                    result[key] = value;
                }
            }
            // Convert number string to number
            for (const key in result) {
                if (Array.isArray(result[key])) {
                    result[key] = result[key].map(v => (isNaN(v) ? v : Number(v)));
                } else {
                    result[key] = result[key];
                }
            }
        
            return result;
        }
        
    }
}
